import React from "react";
import VideoCard from "./VideoCard";
import { Role_Responder_VideoType } from "../utils/types";
import Navbar from "./Navbar";
import useFetch from "../ hooks/useFetch";
import colors from "../utils/colors";

const Sls = () => {
  const data = useFetch("sls");

  console.log(data);

  const UserLoginRenderGrid = (data: Role_Responder_VideoType[]) => {
    return (
      <div style={{ background: colors.SLSsecondary }}>
        <Navbar />
        <div
          style={{
            margin: "50px auto",
            width: "95%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              margin: "0 auto",
              alignContent: "center",
            }}
          >
            {data.map((eachVideo) => {
              return (
                <VideoCard
                  data={eachVideo}
                  key={eachVideo._id}
                  // setVideoURL={setVideoURL}
                  // setIsModalOpen={setIsModalOpen}
                  // videoModalOpen={videoModalOpen}
                  // UrlFunction={UrlFunction}
                  // setIsAuth2nd={setIsAuth2nd}
                  // isAuth2nd={isAuth2nd}
                  // setCurrentVideoThumbnails={setCurrentVideoThumbnails}
                  // setProvider={setProvider}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  return <div>{data.length >= 0 && UserLoginRenderGrid(data)}</div>;
};

export default Sls;
